// store/events.js
import axios from "axios";

const state = {
    events: [],
    pagination: {
        total: 0,
        per_page: 10,
        current_page: 1,
        last_page: 0,
    },
    filters: {
        email: null,
        start_timestamp: null,
        end_timestamp: null,
        mail_type: null,
    },
    mailTypes: [],
};

const mutations = {
    SET_EVENTS(state, events) {
        state.events = events;
    },
    SET_PAGINATION(state, pagination) {
        state.pagination = pagination;
    },
    SET_CURRENT_PAGE(state, page) {
        state.pagination.current_page = page;
    },
    SET_FILTERS(state, filters) {
        state.filters = filters;
    },
    SET_MAIL_TYPES(state, mailTypes) { // Add this mutation to set mail types
        state.mailTypes = mailTypes;
    },
};

const actions = {
    fetchEvents({commit},
                {page = 1, per_page = 10} = {}) {
        const {email, start_timestamp, end_timestamp, mail_type} = state.filters;
        axios.get(`/admin/sendgrid/api/events`, {
            params: {
                email,
                start_timestamp,
                end_timestamp,
                mail_type,
                page,
                per_page,
            },
        })
            .then(response => {
                const data = response.data;
                commit("SET_EVENTS", data.data);
                commit("SET_PAGINATION", {
                    total: data.total,
                    per_page: data.per_page,
                    current_page: data.current_page,
                    last_page: data.last_page,
                });
            });
    },
    async fetchMailTypes({commit}) { // Add this action to fetch mail types
        try {
            const response = await axios.get("/admin/sendgrid/api/list-mail-types");
            commit("SET_MAIL_TYPES", response.data);
        } catch (error) {
            console.error("Error fetching mail types:", error);
        }
    },
    changePage({commit, dispatch}, page) {
        commit("SET_CURRENT_PAGE", page);
        dispatch("fetchEvents", {page, per_page: state.pagination.per_page});
    },
    setFilters({commit, dispatch}, filters) {
        commit("SET_FILTERS", filters);
        dispatch("fetchEvents");
    },
};

const getters = {
    events: state => state.events,
    pagination: state => state.pagination,
    filters: state => state.filters,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
